let filtrePrice = {
    props: {
        pmin: Number,
        pmax: Number,
    },
    directives: {
        clickaway
    },
    data() {
        return {
            isDropdownActive: false,
        }
    },
    methods: {
        clickGroupeFiltres() {
            this.isDropdownActive = !this.isDropdownActive;
            // console.log('label:'+this.isDropdownActive)
        },
        clickChildrenLabel() {
            this.isDropdownActive = false;
            // console.log('away:'+this.isDropdownActive)
        },
        pricevent() {
            this.$root.callfilters(event)
            this.isDropdownActive = false
        },
    },
    // methods: {
    //     filtrevent () {
    //         this.$emit('filtrevent')
    //     }
    // },
    template: `
    <div class="profile filter-block" :class="{ 'is-active': isDropdownActive }" v-clickaway="clickChildrenLabel">
        <h4 @click="clickGroupeFiltres" :class="(pmin != 0 || pmax != 10000) ? 'selected' : ''">Mon budget</h4>
        <div class="filter-content filter-price filters list">
            <ul>
                <li :class="(pmin == '0' && pmax == '10000') ? 'selected filter' : 'filter'">
                    <span @click="pricevent" class="pricevent filter-rbl" data-pmin="0" data-pmax="10000">Tous les prix</span>
                </li>
                <li :class="(pmin == '0' && pmax == '100') ? 'selected filter' : 'filter'">
                    <span @click="pricevent" class="pricevent filter-rbl" data-pmin="0" data-pmax="100">Moins de 100€</span>
                </li>
                <li :class="(pmin == '100' && pmax == '200') ? 'selected filter' : 'filter'">
                    <span @click="pricevent" class="pricevent filter-rbl" data-pmin="100" data-pmax="200">De 100€ à 200€</span>
                </li>
                <li :class="(pmin == '200' && pmax == '10000') ? 'selected filter' : 'filter'">
                    <span @click="pricevent" class="pricevent filter-rbl" data-pmin="200" data-pmax="10000">Supérieur à 200€</span>
                </li>
            </ul>
            <div class="input-number">
                <input type="hidden" name="pmin" class="min-number min-number-price autosize" v-model="pmin">
                <input type="hidden" name="pmax" class="max-number max-number-price autosize" v-model="pmax">
            </div>
        </div>
    </div>
    `
};